/**
 * Cookie management utilities
 */

export class CookieService {
  /**
   * Set a cookie
   * @param {string} name - Cookie name
   * @param {string} value - Cookie value
   * @param {number} [days] - Number of days until the cookie expires
   */
  static setCookie(name, value, days) {
    let expires = "";
    if (typeof days === "number") {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
  }

  /**
   * Get a cookie by name
   * @param {string} name - Cookie name
   * @returns {string|null} - Cookie value or null if not found
   */
  static getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  /**
   * Delete a cookie
   * @param {string} name - Cookie name
   */
  static deleteCookie(name) {
    this.setCookie(name, "", -1);
  }

  /**
   * Check if a cookie exists
   * @param {string} name - Cookie name
   * @returns {boolean} - True if cookie exists
   */
  static hasCookie(name) {
    return this.getCookie(name) !== null;
  }
} 